/**
 * Компактный diff двух сериализованных снимков движка (без функций).
 * @module game/belotArmenian/engineStateDiff
 */

/**
 * @param {unknown} a
 * @param {unknown} b
 * @returns {boolean}
 */
function deepEqual(a, b) {
  if (a === b) return true;
  if (typeof a !== typeof b) return false;
  if (a === null || b === null) return a === b;
  if (typeof a !== 'object') return false;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i += 1) {
      if (!deepEqual(a[i], b[i])) return false;
    }
    return true;
  }
  if (Array.isArray(a) || Array.isArray(b)) return false;
  const ka = Object.keys(/** @type {object} */ (a)).sort();
  const kb = Object.keys(/** @type {object} */ (b)).sort();
  if (ka.length !== kb.length) return false;
  for (let i = 0; i < ka.length; i += 1) {
    if (ka[i] !== kb[i]) return false;
    if (!deepEqual(/** @type {object} */ (a)[ka[i]], /** @type {object} */ (b)[ka[i]])) return false;
  }
  return true;
}

/**
 * @param {unknown} prev
 * @param {unknown} next
 * @param {string} prefix
 * @param {Record<string, { from: unknown, to: unknown }>} out
 */
function diffWalk(prev, next, prefix, out) {
  if (deepEqual(prev, next)) return;
  if (
    prev === null ||
    next === null ||
    typeof prev !== 'object' ||
    typeof next !== 'object' ||
    Array.isArray(prev) !== Array.isArray(next)
  ) {
    out[prefix || '$root'] = { from: prev, to: next };
    return;
  }
  if (Array.isArray(prev) && Array.isArray(next)) {
    const max = Math.max(prev.length, next.length);
    for (let i = 0; i < max; i += 1) {
      const p = `${prefix}[${i}]`;
      if (i >= prev.length) {
        out[p] = { from: undefined, to: next[i] };
      } else if (i >= next.length) {
        out[p] = { from: prev[i], to: undefined };
      } else {
        diffWalk(prev[i], next[i], p, out);
      }
    }
    return;
  }
  const pk = new Set([...Object.keys(/** @type {object} */ (prev)), ...Object.keys(/** @type {object} */ (next))]);
  for (const k of pk) {
    const path = prefix ? `${prefix}.${k}` : k;
    if (!Object.prototype.hasOwnProperty.call(prev, k)) {
      out[path] = { from: undefined, to: /** @type {object} */ (next)[k] };
    } else if (!Object.prototype.hasOwnProperty.call(next, k)) {
      out[path] = { from: /** @type {object} */ (prev)[k], to: undefined };
    } else {
      diffWalk(/** @type {object} */ (prev)[k], /** @type {object} */ (next)[k], path, out);
    }
  }
}

/**
 * @param {Record<string, unknown>|null} prevSerialized
 * @param {Record<string, unknown>|null} nextSerialized
 * @returns {Record<string, { from: unknown, to: unknown }>}
 */
function diffSerializedEngineStates(prevSerialized, nextSerialized) {
  if (!prevSerialized || !nextSerialized || typeof prevSerialized !== 'object' || typeof nextSerialized !== 'object') {
    return { _diff: { from: prevSerialized, to: nextSerialized } };
  }
  /** @type {Record<string, { from: unknown, to: unknown }>} */
  const out = {};
  diffWalk(prevSerialized, nextSerialized, '', out);
  return out;
}

module.exports = {
  diffSerializedEngineStates,
  deepEqual,
};
